module.exports = __webpack_public_path__ + "img/ic_32_register_facebook-active.f622f4c9.svg";